import { Component, OnInit, ViewChild } from '@angular/core';
import { NgControl } from '@angular/forms';
import { distinctUntilChanged, debounceTime, skip } from 'rxjs/operators';
import { DefaultFilter } from './default-filter';

@Component({
    selector: 'select-filter',
    template: `
    <select
      [ngClass]="inputClass"
      class="form-control"
      #inputControl
      [(ngModel)]="query"
    >
      <option value="">{{ column.getFilterConfig().selectText }}</option>
      <option
        *ngFor="let option of listData"
        [value]="option.value"
      >
        {{ option.title }}
      </option>
    </select>
  `,
    standalone: false
})
export class SelectFilterComponent extends DefaultFilter implements OnInit {
  @ViewChild('inputControl', { read: NgControl, static: true })
  inputControl: NgControl;
  listData: Array<{ value: string, title: string }> = [];
  constructor() {
    super();
  }

  ngOnInit() {
    if (this.column.getFilterConfig().isApi && this.column.getFilterConfig().getApi() != null) {
      this.column.getFilterConfig().getApi()
        .subscribe((result: any) => {
          if (result) {
            result.forEach(element => {
              this.listData.push({ value: element.display, title: element.display });
            });
          }
        });
    } else {
      this.listData = this.column.getFilterConfig().list;
    }
    this.inputControl.valueChanges
      .pipe(skip(1), distinctUntilChanged(), debounceTime(this.delay))
      .subscribe((value: string) => this.setFilter());
  }
}
